import { Alert, Space, Typography } from 'antd'
import type { TFunction } from 'i18next'
import { useTranslation } from 'react-i18next'
import type { ReportNote, ReportNotices } from './attendanceApi'

interface ReportNoticesAlertProps {
  notices: ReportNotices
  /** Hisobotga xos qo'shimcha ogohlantirishlar (masalan tanilmagan urinishlar) */
  extra?: readonly string[]
  style?: React.CSSProperties
}

/**
 * Hisobot ogohlantirishlari.
 *
 * <h2>⚠️ NEGA BU KOMPONENT UMUMAN BOR</h2>
 * Backend har hisobot bilan birga `notes`, `truncated` va `multiZone`
 * yuboradi. Ularni tashlab yuborish texnik jihatdan hech narsani
 * buzmasdi — jadval baribir chizilardi. Lekin natija YOMONROQ bo'lardi:
 * hisobot haqiqiydan ko'ra ISHONCHLIROQ ko'rinardi.
 *
 * Bu raqamlar bo'yicha ish haqi hisoblanadi va intizom qarorlari
 * qabul qilinadi. Shuning uchun "bu raqam qanchalik ishonchli" degan
 * savol raqamning O'ZI bilan bir xil darajada muhim, va unga javob
 * jadvalning YONIDA turishi kerak — hujjatda emas, tooltip'da emas.
 *
 * <h2>Uch xil ogohlantirish, uch xil sabab</h2>
 *   · `truncated` — natija KESILGAN. Eng xavflisi: kesilgan ro'yxat
 *     to'liq ro'yxatdan farq qilmaydi, u shunchaki qisqaroq. Busiz
 *     operator "bu xodim kelmagan" degan xulosaga kelardi, holbuki
 *     qator chegaradan tashqarida qolgan
 *   · `multiZone` — bir necha vaqt zonasi aralashgan, ya'ni "kun"
 *     tushunchasi bitta emas. Raqam noto'g'ri emas, SHARTLI
 *   · `notes` — serverning ogohlantirishlari. ⚠️ ULAR ENDI TARJIMA
 *     QILINADI. Ilgari bu yerda "server vaziyatni bizdan yaxshi biladi"
 *     degan mulohaza bilan XOM matn chizilardi — va u tashqi testerda
 *     aynan shu blokni buzdi (C2): inglizcha hisobotning ishonchlilik
 *     ogohlantirishi butunlay o'zbekcha chiqardi. Mulohazaning o'zi
 *     to'g'ri edi, xulosa noto'g'ri: server VAZIYATNI biladi, TILNI
 *     esa panel biladi. Shuning uchun server `code` + `params`
 *     yuboradi, matnni panel yasaydi
 *
 * <h2>⚠️ TURI — `warning`, `info` EMAS</h2>
 * `info` ko'k va u "foydali qo'shimcha" bo'lib o'qiladi, ya'ni e'tibordan
 * chetda qoladi. Bu esa ma'lumotning ishonchliligi haqidagi gap.
 */
/**
 * Server ogohlantirishini o'qiladigan matnga aylantiradi.
 *
 * ⚠️ NOMA'LUM KOD YASHIRILMAYDI — serverning O'Z matni chiqadi.
 * Bu `verifyMethodLabel` dagi bilan bir xil qaror va sababi ham bir
 * xil: bo'sh joy "ogohlantirish yo'q" bo'lib o'qilardi, holbuki u BOR
 * — biz uni hali tarjima qilmaganmiz. Ma'lumot ishonchliligi haqidagi
 * blokda bu farq hal qiluvchi.
 *
 * ⚠️ `params` `i18next` ga TO'G'RIDAN-TO'G'RI beriladi va kalitdagi
 * `{{count}}` / `{{zones}}` shundan to'ladi. `count` nomi ataylab:
 * i18next uni ko'plik shakli uchun ham ishlatadi.
 */
function noticeText(note: ReportNote, t: TFunction): string {
  const key = `attendance.report.notice.${note.code}`
  const translated = t(key, { ...(note.params ?? {}), defaultValue: '' })
  return translated === '' ? note.text : translated
}

export function ReportNoticesAlert({ notices, extra = [], style }: ReportNoticesAlertProps) {
  const { t } = useTranslation()

  const lines: string[] = []

  if (notices.truncated) lines.push(t('attendance.report.noticeTruncated'))
  if (notices.multiZone) {
    lines.push(
      t('attendance.report.noticeMultiZone', {
        zones: notices.zones.length > 0 ? notices.zones.join(', ') : '—',
      }),
    )
  }
  lines.push(...extra)
  // Server ogohlantirishlari OXIRIDA: yuqoridagilar barqaror, bular esa
  // o'zgaruvchan. Aralashtirib qo'yish ro'yxatni har safar boshqa
  // tartibda ko'rsatardi.
  lines.push(...notices.notes.map((note) => noticeText(note, t)))

  if (lines.length === 0) return null

  return (
    <Alert
      type="warning"
      showIcon
      style={style}
      message={t('attendance.report.noticeTitle')}
      description={
        <Space direction="vertical" size={2}>
          {lines.map((line, index) => (
            <Typography.Text key={index}>{line}</Typography.Text>
          ))}
        </Space>
      }
    />
  )
}
